(function () {
  'use strict';

  function euros(cents) {
    return (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  class MtProductBuy extends HTMLElement {
    connectedCallback() {
      this.designs = JSON.parse(this.querySelector('[data-mt-designs]').textContent);
      this.pricing = JSON.parse(this.querySelector('[data-mt-pricing]').textContent);
      this.i18n = JSON.parse(this.querySelector('[data-mt-i18n]').textContent);
      this.variantMap = JSON.parse(this.querySelector('[data-mt-variant-map]').textContent);
      const sizesEl = this.querySelector('[data-mt-sizes]');
      this.sizes = sizesEl ? JSON.parse(sizesEl.textContent) : null;

      this.selectedDesign = this.designs[0].id;
      this.selectedSize = this.sizes ? this.sizes[0].value : null;
      this.pack = 1;
      this.slotDesigns = [this.selectedDesign];
      this.slotSelections = [{ design: this.selectedDesign, size: this.selectedSize }];

      this.swatchButtons = Array.from(this.querySelectorAll('.mt-swatch'));
      this.sizeButtons = Array.from(this.querySelectorAll('[data-mt-sizes-selector] .mt-size-pill'));
      this.packCards = Array.from(this.querySelectorAll('.mt-pack-card'));
      this.slotsWrapper = this.querySelector('[data-mt-slots]');
      this.priceEl = this.querySelector('[data-mt-current-price]');
      this.addButton = this.querySelector('[data-mt-add-to-cart]');
      this.errorEl = this.querySelector('[data-mt-error]');

      this.swatchButtons.forEach((btn) => btn.addEventListener('click', () => this.onSwatchClick(btn)));
      this.sizeButtons.forEach((btn) => btn.addEventListener('click', () => this.onSizeClick(btn)));
      this.packCards.forEach((card) => card.addEventListener('click', () => this.onPackClick(card)));
      this.addButton.addEventListener('click', (e) => this.onAddClick(e));

      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      this.renderSlots();
      this.updatePrice();
      this.setupStickyBar();
      this.setupUpsellPopup();
      this.setupRatingScroll();
      this.setupCarousel();
      this.setupSizeGuide();
      this.filterSlidesByDesign(this.selectedDesign);
    }

    onSwatchClick(btn) {
      this.swatchButtons.forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      this.selectedDesign = btn.dataset.designId;
      if (this.pack === 1) this.slotDesigns = [this.selectedDesign];
      this.filterSlidesByDesign(this.selectedDesign);
      if (!this.sizes) this.renderSlots();
    }

    onSizeClick(btn) {
      this.sizeButtons.forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      this.selectedSize = btn.dataset.sizeValue;
    }

    setupCarousel() {
      this.carousel = document.querySelector('[data-mt-carousel]');
      this.dotsWrapper = document.querySelector('[data-mt-dots]');
      if (!this.carousel) return;
      this.allSlides = Array.from(this.carousel.querySelectorAll('[data-mt-slide]'));
      this.slides = this.allSlides;
    }

    filterSlidesByDesign(designId) {
      if (!this.allSlides) return;
      this.allSlides.forEach((slide) => {
        const slideDesign = slide.dataset.mtSlideDesign;
        slide.hidden = !!slideDesign && String(slideDesign) !== String(designId);
      });
      this.slides = this.allSlides.filter((slide) => !slide.hidden);
      this.rebuildDots();
      if (this.slides[0]) this.carousel.scrollLeft = this.slides[0].offsetLeft;
    }

    rebuildDots() {
      if (!this.dotsWrapper) return;
      if (this.dotsObserver) this.dotsObserver.disconnect();

      if (this.slides.length <= 1) {
        this.dotsWrapper.hidden = true;
        this.dotsWrapper.innerHTML = '';
        this.dots = [];
        return;
      }

      this.dotsWrapper.hidden = false;
      this.dotsWrapper.innerHTML = this.slides
        .map(
          (_, i) => `<button type="button" class="mt-product__dot${i === 0 ? ' is-active' : ''}" data-mt-dot="${i}" aria-label="${this.i18n.viewPhotoAria}"></button>`
        )
        .join('');
      this.dots = Array.from(this.dotsWrapper.querySelectorAll('[data-mt-dot]'));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.scrollCarouselToIndex(parseInt(dot.dataset.mtDot, 10)));
      });

      if (window.IntersectionObserver) {
        this.dotsObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const index = this.slides.indexOf(entry.target);
                this.dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
              }
            });
          },
          { root: this.carousel, threshold: 0.6 }
        );
        this.slides.forEach((s) => this.dotsObserver.observe(s));
      }
    }

    scrollCarouselToIndex(index) {
      if (!this.slides || !this.carousel) return;
      const slide = this.slides[index];
      if (slide) this.carousel.scrollLeft = slide.offsetLeft;
    }

    onPackClick(card) {
      this.packCards.forEach((c) => c.classList.remove('is-selected'));
      card.classList.add('is-selected');
      this.pack = parseInt(card.dataset.pack, 10);
      this.slotDesigns = new Array(this.pack).fill(this.selectedDesign);
      this.slotSelections = new Array(this.pack).fill(null).map(() => ({
        design: this.selectedDesign,
        size: this.selectedSize,
      }));
      this.renderSlots();
      this.updatePrice();
    }

    renderSlots() {
      if (!this.slotsWrapper) return;
      if (this.pack === 1) {
        this.slotsWrapper.innerHTML = '';
        this.slotsWrapper.hidden = true;
        return;
      }
      this.slotsWrapper.hidden = false;
      this.slotsWrapper.innerHTML = this.sizes ? this.renderSlotsWithSizes() : this.renderSlotsDesignOnly();
      this.wireSlotEvents();
    }

    renderSlotsDesignOnly() {
      return (
        `<p class="mt-slots__label">${this.i18n.slotLabel}</p>` +
        this.slotDesigns
          .map(
            (designId, i) => `
        <div class="mt-slot" data-slot-index="${i}">
          <span class="mt-slot__index">${this.i18n.slotIndexPrefix} ${i + 1}</span>
          <div class="mt-swatches mt-swatches--slot">
            ${this.designs
              .map(
                (d) => `
              <button type="button" class="mt-swatch mt-swatch--slot${String(d.id) === String(designId) ? ' is-selected' : ''}" data-slot="${i}" data-design-id="${d.id}">
                <span class="mt-swatch__thumb">${d.image ? `<img src="${d.image}" alt="${d.title}" loading="lazy">` : ''}</span>
                <span class="mt-swatch__label">${d.title}</span>
              </button>`
              )
              .join('')}
          </div>
        </div>`
          )
          .join('')
      );
    }

    renderSlotsWithSizes() {
      return (
        `<p class="mt-slots__label">${this.i18n.slotLabel}</p>` +
        this.slotSelections
          .map(
            (sel, i) => `
        <div class="mt-slot" data-slot-index="${i}">
          <span class="mt-slot__index">${this.i18n.slotIndexPrefix} ${i + 1}</span>
          <div class="mt-swatches mt-swatches--slot">
            ${this.designs
              .map(
                (d) => `
              <button type="button" class="mt-swatch mt-swatch--slot${String(d.id) === String(sel.design) ? ' is-selected' : ''}" data-slot="${i}" data-design-id="${d.id}">
                <span class="mt-swatch__thumb">${d.image ? `<img src="${d.image}" alt="${d.title}" loading="lazy">` : ''}</span>
                <span class="mt-swatch__label">${d.title}</span>
              </button>`
              )
              .join('')}
          </div>
          <div class="mt-sizes mt-sizes--slot">
            ${this.sizes
              .map(
                (s) => `
              <button type="button" class="mt-size-pill mt-size-pill--slot${String(s.value) === String(sel.size) ? ' is-selected' : ''}" data-slot="${i}" data-size-value="${s.value}">${s.value}</button>`
              )
              .join('')}
          </div>
        </div>`
          )
          .join('')
      );
    }

    wireSlotEvents() {
      this.slotsWrapper.querySelectorAll('.mt-swatch--slot').forEach((btn) => {
        btn.addEventListener('click', () => {
          const slot = parseInt(btn.dataset.slot, 10);
          if (this.sizes) {
            this.slotSelections[slot].design = btn.dataset.designId;
          } else {
            this.slotDesigns[slot] = btn.dataset.designId;
          }
          this.renderSlots();
        });
      });
      this.slotsWrapper.querySelectorAll('.mt-size-pill--slot').forEach((btn) => {
        btn.addEventListener('click', () => {
          const slot = parseInt(btn.dataset.slot, 10);
          this.slotSelections[slot].size = btn.dataset.sizeValue;
          this.renderSlots();
        });
      });
    }

    updatePrice() {
      const price = this.pricing[this.pack];
      if (this.priceEl && price) this.priceEl.textContent = euros(price);
    }

    resolveVariantId(designId, size) {
      const key = this.sizes ? `${designId}|${size != null ? size : this.selectedSize}` : String(designId);
      return this.variantMap[key];
    }

    getLineItems() {
      if (this.sizes && this.pack > 1) {
        const counts = {};
        this.slotSelections.forEach((sel) => {
          const variantId = this.resolveVariantId(sel.design, sel.size);
          if (!variantId) return;
          counts[variantId] = (counts[variantId] || 0) + 1;
        });
        return Object.keys(counts).map((id) => ({ id: parseInt(id, 10), quantity: counts[id] }));
      }
      if (this.sizes) {
        const variantId = this.resolveVariantId(this.selectedDesign);
        return variantId ? [{ id: parseInt(variantId, 10), quantity: this.pack }] : [];
      }
      const counts = {};
      this.slotDesigns.forEach((id) => {
        const variantId = this.resolveVariantId(id);
        if (!variantId) return;
        counts[variantId] = (counts[variantId] || 0) + 1;
      });
      return Object.keys(counts).map((id) => ({ id: parseInt(id, 10), quantity: counts[id] }));
    }

    onAddClick(evt) {
      evt.preventDefault();
      if (this.pack === 1 && !sessionStorage.getItem('mtUpsellShown')) {
        sessionStorage.setItem('mtUpsellShown', '1');
        this.openUpsellPopup();
        return;
      }
      this.addToCart();
    }

    addToCart() {
      this.errorEl.textContent = '';
      const items = this.getLineItems();
      if (!items.length) {
        this.errorEl.textContent = this.i18n.addToCartError;
        return;
      }
      this.addButton.setAttribute('aria-disabled', 'true');
      this.addButton.classList.add('loading');

      const body = { items };
      if (this.cart) {
        body.sections = this.cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      })
        .then((r) => r.json())
        .then((response) => {
          if (response.status) {
            this.errorEl.textContent = response.description || response.message || this.i18n.addToCartError;
            return;
          }
          if (this.cart) {
            this.cart.renderContents(response);
          } else {
            window.location = window.routes.cart_url;
          }
        })
        .catch(() => {
          this.errorEl.textContent = this.i18n.networkError;
        })
        .finally(() => {
          this.addButton.removeAttribute('aria-disabled');
          this.addButton.classList.remove('loading');
        });
    }

    setupStickyBar() {
      this.stickyBar = document.querySelector('[data-mt-sticky-atc]');
      if (!this.stickyBar || !window.IntersectionObserver) return;
      const stickyPrice = this.stickyBar.querySelector('[data-mt-sticky-price]');
      const stickyButton = this.stickyBar.querySelector('[data-mt-sticky-add]');
      stickyButton.addEventListener('click', (e) => this.onAddClick(e));

      const originalUpdatePrice = this.updatePrice.bind(this);
      this.updatePrice = () => {
        originalUpdatePrice();
        if (stickyPrice) stickyPrice.textContent = this.priceEl.textContent;
      };
      this.updatePrice();

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { rootMargin: '0px 0px -10% 0px' }
      );
      observer.observe(this.addButton);
    }

    setupUpsellPopup() {
      this.popup = document.querySelector('[data-mt-upsell-popup]');
      if (!this.popup) return;
      this.popup.querySelectorAll('[data-mt-upsell-choose]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const pack = parseInt(btn.dataset.mtUpsellChoose, 10);
          if (pack > 1) {
            const card = this.packCards.find((c) => parseInt(c.dataset.pack, 10) === pack);
            if (card) this.onPackClick(card);
          }
          this.closeUpsellPopup();
          this.addToCart();
        });
      });
      this.popup.querySelectorAll('[data-mt-upsell-close]').forEach((btn) => {
        btn.addEventListener('click', () => this.closeUpsellPopup());
      });
    }

    openUpsellPopup() {
      if (this.popup) this.popup.classList.add('is-open');
    }

    closeUpsellPopup() {
      if (this.popup) this.popup.classList.remove('is-open');
    }

    setupRatingScroll() {
      const ratingLink = document.querySelector('[data-mt-rating-link]');
      const target = document.querySelector('#mt-reviews');
      if (ratingLink && target) {
        ratingLink.addEventListener('click', (e) => {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }

    setupSizeGuide() {
      const openBtn = document.querySelector('[data-mt-size-guide-open]');
      const modal = document.querySelector('[data-mt-size-guide]');
      if (!openBtn || !modal) return;
      const close = () => modal.classList.remove('is-open');
      openBtn.addEventListener('click', () => modal.classList.add('is-open'));
      modal.querySelectorAll('[data-mt-size-guide-close]').forEach((btn) => btn.addEventListener('click', close));
    }
  }

  customElements.define('mt-product-buy', MtProductBuy);
})();
